import { OrderStatusEnum } from '@ztechapps/common.contract'

/**
 * Order statuses that count as a committed charge — the AR "charge" gate shared
 * by the company statement, the aging report, and the order-list filters.
 * Excludes In Cart, Quotation and Cancelled.
 */
export const COMMITTED_ORDER_STATUSES: OrderStatusEnum[] = [
  OrderStatusEnum.Order,
  OrderStatusEnum.InProgress,
  OrderStatusEnum.ReadyForPayment,
  OrderStatusEnum.Paid,
  OrderStatusEnum.Packing,
  OrderStatusEnum.Shipped,
  OrderStatusEnum.InTransit,
  OrderStatusEnum.Delivered,
]
